module.exports = __webpack_public_path__ + "static/ajoy-anand-1ddf3a536cabe6be3dfe4c2c2a90153a.webp";